(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["georgia-get-the-look-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.georgia-look--gallery').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-georgia-look-tab]');
      var items = root.querySelectorAll('[data-georgia-look-item]');

      function activate(category) {
        tabs.forEach(function (t) {
          var isActive = t.getAttribute('data-category') === category;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        items.forEach(function (item) {
          var show = category === 'all' || item.getAttribute('data-category') === category;
          if (show) {
            item.removeAttribute('data-georgia-look-hidden');
          } else {
            item.setAttribute('data-georgia-look-hidden', '');
          }
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activate(tab.getAttribute('data-category'));
        });
      });

      var validCategories = ['trendy', 'casual', 'denim', 'cozy', 'sports', 'party'];
      var params = new URLSearchParams(window.location.search);
      var requested = (params.get('category') || '').toLowerCase();
      var initial = validCategories.indexOf(requested) !== -1 ? requested : 'all';

      activate(initial);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
